import { createSelector } from 'reselect'
import { createArraySelector } from 'reselect-map'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.RICH_TEXT_QUIZ,
	featureFlagsTypes.RICH_TEXT_MATH_FORMULAS_PLUGIN,
])


const quizSelector = state => state.quiz
const questionsSelector = state => state.quiz.questions

const questionsWithErrorsSelector = createArraySelector(
	[questionsSelector],
	qst => ({
		...qst,
		textErrors: !qst.text ? 'Please include text for this question' : '',
		noCorrectAnswerError: qst.answers.filter(ans => ans.correct).length === 0 ? 'Please select a correct answer' : '',
		answers: qst.answers.map(ans => ({
			...ans,
			textErrors: !ans.text ? 'Please include text for this answer' : '',
		})),
		hasErrors: (() => {
			const questionTextError = (!qst.text && !qst.textTouched) || qst.hasExceedChars
			const questionAnswersError = qst.answers.filter(ans => ans.correct).length === 0 && !qst.touched
			const answersError = qst.answers.filter(ans => ans.text === '' && !ans.textTouched).length > 0
			return questionTextError || questionAnswersError || answersError
		})(),
	})
)

const questionsExpandedSelector = createSelector(
	[questionsSelector],
	questions => questions.filter(question => !question.collapsed).length !== 0
)

export default createSelector(
	[quizSelector, questionsWithErrorsSelector, questionsExpandedSelector, featureFlagsSelector],
	(quizState, questions, someExpanded, featureFlags) => {
		const shouldUseRichText = featureFlags[featureFlagsTypes.RICH_TEXT_QUIZ]

		return {
			...quizState,
			questions: questions.filter(question => question.status !== 'deleting'),
			someExpanded,
			shouldUseRichText,
			shouldUseRichTextMathFormula: featureFlags[featureFlagsTypes.RICH_TEXT_MATH_FORMULAS_PLUGIN],
		}
	}
)
